import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import store from "./store";

// remove polyfill
((arr) => {
  arr.forEach((item) => {
    item.remove =
      item.remove ||
      (() => {
        if (this && this.parentNode && this.parentNode.removeChild) {
          this.parentNode.removeChild(this);
        }
      });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
